import BonusGamePage from './BonusGamePage';
export default BonusGamePage;
